import request from '@/utils/request'

const dataObj = {
	version: '1.0',
	nonceStr: '1212fsadf',
	timestamp: '2020-4-21',
	signType: 'md5',
	content: { object: {} },
	sign: 'dafdsf'
}
// 分页查询账户
export const getAccList = (data) => {
	return request({
		url: '/api/v3/accInfo/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 账户导出
export const exportAccList = (data) => {
	return request({
		url: '/api/v3/accInfo/page/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}
// 单个人修改账户信息
export const editAcc = (data) => {
	return request({
		url: '/api/v3/accInfo/update/info/single',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 批量修改账户信息
export const pleditAcc = (data) => {
	return request({
		url: '/api/v3/accInfo/update/info/batch',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 账户启用、停用、注销
export const stateAcc = (data) => {
	return request({
		url: '/api/v3/accInfo/update/state',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 账户操作记录
export const getOperationList = (data) => {
	return request({
		url: '/api/v3/accInfo/operation/list',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 账户操作记录导出
export const exportOperationList = (data) => {
	return request({
		url: '/api/v3/accInfo/operation/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}
// 补贴汇总记录
export const getSubsidySummaryList = (data) => {
	return request({
		url: '/api/v3/acc/subsidy/recharge/collect/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 补贴汇总记录导出
export const exportSubsidySummaryList = (data) => {
	return request({
		url: '/api/v3/acc/subsidy/recharge/collect/page/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}
// 补贴单人充值
export const addSingleSubsidy = (data) => {
	return request({
		url: '/api/v3/acc/subsidy/recharge/single',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 批量补贴充值
export const addAllSubsidy = (data) => {
	return request({
		url: '/api/v3/acc/subsidy/recharge/batch',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 补贴单人清空
export const clearSingleSubsidy = (data) => {
	return request({
		url: '/api/v3/acc/subsidy/clear/single',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 批量补贴清空
export const clearAllSubsidy = (data) => {
	return request({
		url: '/api/v3/acc/subsidy/clear/batch',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 获取补贴记录
export const getButieHistory = (data) => {
	return request({
		url: '/api/v3/acc/subsidy/recharge/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 导出补贴记录
export const exportButieHistory = (data) => {
	return request({
		url: '/api/v3/acc/subsidy/recharge/page/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}
// 获取补贴清空记录
export const getButieClearHistory = (data) => {
	return request({
		url: '/api/v3/acc/subsidy/clear/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// // 导出补贴清空记录
export const exportButieClearHistory = (data) => {
	return request({
		url: '/api/v3/acc/subsidy/clear/page/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}

// 消费明细
export const getConsumeList = (data) => {
	return request({
		url: '/account/consume/flowinfo/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const exportConsumeList = (data) => {
	return request({
		url: '/account/consume/flowinfo/export',
		method: 'post',
		responseType: 'blob',
		data: { ...dataObj, content: data || undefined }
	})
}
// 补贴规则新增
export const addButieList = (data) => {
	return request({
		url: '/api/v3/acc/subsidy/rule/add',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 补贴规则列表获取
export const getButieList = (data) => {
	return request({
		url: '/api/v3/acc/subsidy/rule/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 补贴规则删除
export const delButieList = (data) => {
	return request({
		url: '/api/v3/acc/subsidy/rule/update/state',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 补贴批量导入校验
export const exportButiejiaoyanV3 = (data) => {
	return request({
		// url: "/api/v3/acc/subsidy/import/recharge",
		url: '/api/v3/acc/subsidy/import/check',

		method: 'post',
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		data
	})
}
// 补贴批量导入校验
export const exportButiechongzhiV3 = (data) => {
	return request({
		url: '/api/v3/acc/subsidy/import/recharge',
		// url: "/api/v3/acc/subsidy/import/check",
		method: 'post',
		// headers: {
		//   "Content-Type": "multipart/form-data"
		// },
		data: { ...dataObj, content: data || undefined }
	})
}
// 补贴导入轮询结果查询-轮询
export const getButieImportResultV3 = () => {
	return request({
		url: '/api/v3/acc/subsidy/import/result',
		params: dataObj,
		noLoading: true
	})
}

// 消费汇总
export const getConsumeSummary = (data) => {
	return request({
		url: '/account/sum/canteen/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 充值
export const singleRecharge = (data) => {
	return request({
		url: '/api/v3/acc/wallet/recharge/single',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 批量充值
export const batchRecharge = (data) => {
	return request({
		url: '/api/v3/acc/wallet/recharge/batch',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 提现
export const singleWithdraw = (data) => {
	return request({
		url: '/api/v3/acc/withdraw/single',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 批量提现
export const batchWithdraw = (data) => {
	return request({
		url: '/api/v3/acc/withdraw/batch',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 补扣
export const singleDeduct = (data) => {
	return request({
		url: '/api/v3/acc/consume/single/repair/deduct',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 批量补扣
export const batchDeduct = (data) => {
	return request({
		url: '/api/v3/acc/consume/batch/repair/deduct',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 提现申请列表
export const getWithdrawApplyList = (data) => {
	return request({
		url: '/api/v3/acc/withdraw/apply/record',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 审批同意
export const agreeWithdrawApply = (data) => {
	return request({
		url: '/api/v3/acc/withdraw/apply/agree',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 审批拒绝
export const refuseWithdrawApply = (data) => {
	return request({
		url: '/api/v3/acc/withdraw/apply/reject',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 充值明细
export const getRechargeList = (data) => {
	return request({
		url: '/api/v3/acc/wallet/recharge/details',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 充值明细导出
export const exportRechargeList = (data) => {
	return request({
		url: '/api/v3/acc/wallet/recharge/details/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}

// 提现明细
export const getWithdrawList = (data) => {
	return request({
		url: '/api/v3/acc/withdraw/page/details',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 提现明细导出
export const exportWithdrawList = (data) => {
	return request({
		url: '/api/v3/acc/withdraw/page/details/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}
// 新增定时冻结规则
export const addFreezeRule = (data) => {
	return request({
		url: '/api/v3/time/acc/frozen/rule/add',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 获取定时冻结规则
export const getFreezeRule = (data) => {
	return request({
		url: '/api/v3/time/acc/frozen/rule/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 修改定时冻结规则
export const editFreezeRule = (data) => {
	return request({
		url: '/api/v3/time/acc/frozen/rule/update/info',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 状态变更 定时冻结规则
export const changeFreezeRule = (data) => {
	return request({
		url: '/api/v3/time/acc/frozen/rule/update/state',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 单个人解冻
export const accUnfrozen = (data) => {
	return request({
		url: '/api/v3/acc/frozen/single/unfrozen',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 单个人冻结
export const accFrozen = (data) => {
	return request({
		url: '/api/v3/acc/frozen/single/frozen',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 批量冻结余额接口
export const accsFrozen = (data) => {
	return request({
		url: '/api/v3/acc/frozen/batch/frozen',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 批量解冻余额接口
export const accsUnfrozen = (data) => {
	return request({
		url: '/api/v3/acc/frozen/batch/unfrozen',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 查询已冻结的人员数据接口
export const getFrozenList = (data) => {
	return request({
		url: '/api/v3/acc/frozen/cust/list',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 冻结明细
export const getFreezeAccount = (data) => {
	return request({
		url: '/api/v3/acc/frozen/page/frozen',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 导出冻结明细
export const exportFreezeAccount = (data) => {
	return request({
		url: '/api/v3/acc/frozen/page/frozen/export',
		method: 'post',
		responseType: 'blob',
		data: { ...dataObj, content: data || undefined }
	})
}
// 解冻明细
export const getUnfreezeAccount = (data) => {
	return request({
		url: '/api/v3/acc/frozen/page/unfrozen',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 导出解冻明细
export const exportUnfreezeAccount = (data) => {
	return request({
		url: '/api/v3/acc/frozen/page/unfrozen/export',
		method: 'post',
		responseType: 'blob',
		data: { ...dataObj, content: data || undefined }
	})
}
// 单人转账
export const singleTransfer = (data) => {
	return request({
		url: '/api/v3/acc/transfer/single',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 批量转账
export const batchTransfer = (data) => {
	return request({
		url: '/api/v3/acc/transfer/batch',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 审批记录列表
export const getApprovalList = (data) => {
	return request({
		url: '/api/v3/acc/withdraw/approval/record',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 审批记录导出
export const exportApprovalList = (data) => {
	return request({
		url: '/api/v3/acc/withdraw/approval/record/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}

// 提现审批记录列表
export const getApplyList = (data) => {
	return request({
		url: '/api/v3/acc/withdraw/apply/record',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		mock: false
	})
}
// 提现审批记录导出
export const exportApplyList = (data) => {
	return request({
		url: '/api/v3/acc/withdraw/apply/record/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob',
		mock: false
	})
}
// 获取枚举字段
export const getAccenum = (data) => {
	return request({
		url: '/api/v3/accInfo/all-acc-enum',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 充值汇总
export const getRechargeSummary = (data) => {
	return request({
		url: '/api/v3/acc/wallet/recharge/collect/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 充值汇总导出
export const exportRechargeSummary = (data) => {
	return request({
		url: '/api/v3/acc/wallet/recharge/collect/page/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}
// 提现汇总
export const getWithdrawSummary = (data) => {
	return request({
		url: '/api/v3/acc/withdraw/page/sum',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 提现汇总导出
export const exportWithdrawSummary = (data) => {
	return request({
		url: '/api/v3/acc/withdraw/page/sum/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}
// 红包发放
export const singleRedbag = (data) => {
	return request({
		url: '/api/v3/acc/red/recharge/single',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 批量红包发放
export const batchRedbag = (data) => {
	return request({
		url: '/api/v3/acc/red/recharge/batch',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 充值方式汇总
export const getRechargeTypeSummary = (data) => {
	return request({
		url: '/api/v3/acc/wallet/recharge/trade-type/collect/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 充值方式导出
export const exportRechargeTypeSummary = (data) => {
	return request({
		url: '/api/v3/acc/wallet/recharge/trade-type/collect/page/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}
// 提现方式汇总
export const getWithdrawTypeSummary = (data) => {
	return request({
		url: '/api/v3/acc/withdraw/trade-type/page/sum',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 提现方式导出
export const exportWithdrawTypeSummary = (data) => {
	return request({
		url: '/api/v3/acc/withdraw/trade-type/page/sum/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}
// 转账记录
export const getTransferList = (data) => {
	return request({
		url: '/api/v3/acc/transfer/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 转账记录导出
export const exportTransferList = (data) => {
	return request({
		url: '/api/v3/acc/transfer/page/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}
// 红包发放记录
export const getRedbagList = (data) => {
	return request({
		url: '/api/v3/acc/red/recharge/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 红包发放记录导出
export const exportRedbagList = (data) => {
	return request({
		url: '/api/v3/acc/red/recharge/page/export',
		method: 'post',
		responseType: 'blob',
		data: { ...dataObj, content: data || undefined }
	})
}
// 获取设备/小程序扣款配置
export const getdeductionList = (data) => {
	return request({
		url: '/api/v3/acc/deduction/list',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 更新设备/小程序扣款配置
export const adddeduction = (data) => {
	return request({
		url: '/api/v3/acc/deduction/add',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 获取账户详细信息
export const getAccDetail = (data) => {
	return request({
		url: '/api/v3/accInfo/detail',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 报表
// 出纳汇总
export const getCashierList = (data) => {
	return request({
		url: '/summary/account/operator/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const exportCashierList = (data) => {
	return request({
		url: '/summary/account/operator/export',
		method: 'post',
		responseType: 'blob',
		data: { ...dataObj, content: data || undefined }
	})
}
// 组织分类汇总
export const getOrgclassifyList = (data) => {
	return request({
		url: '/summary/account/organization/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const exportOrgclassifyList = (data) => {
	return request({
		url: '/summary/account/organization/export',
		method: 'post',
		responseType: 'blob',
		data: { ...dataObj, content: data || undefined }
	})
}
// 人员分类汇总
export const getPersonclassifyList = (data) => {
	return request({
		url: '/summary/account/cust/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const exportPersonclassifyList = (data) => {
	return request({
		url: '/summary/account/cust/export',
		method: 'post',
		responseType: 'blob',
		data: { ...dataObj, content: data || undefined }
	})
}
// 类别分类汇总
export const getTypeclassifyList = (data) => {
	return request({
		url: '/summary/account/psn/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const exportTypeclassifyList = (data) => {
	return request({
		url: '/summary/account/psn/export',
		method: 'post',
		responseType: 'blob',
		data: { ...dataObj, content: data || undefined }
	})
}
// 变动流水表
export const getFlowinfoList = (data) => {
	return request({
		url: '/summary/account/flow/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const exportFlowinfoList = (data) => {
	return request({
		url: '/summary/account/flow/export',
		method: 'post',
		responseType: 'blob',
		data: { ...dataObj, content: data || undefined }
	})
}
// 消费汇总
export const getCanteensumList = (data) => {
	return request({
		url: '/account/sum/canteen/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const exportCanteensumList = (data) => {
	return request({
		url: '/account/sum/canteen/export',
		method: 'post',
		responseType: 'blob',
		data: { ...dataObj, content: data || undefined }
	})
}
export const getNuclearmodesumList = (data) => {
	return request({
		url: '/account/sum/nuclearmode/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const exportNuclearmodesumList = (data) => {
	return request({
		url: '/account/sum/nuclearmode/export',
		method: 'post',
		responseType: 'blob',
		data: { ...dataObj, content: data || undefined }
	})
}
export const getOrgsumList = (data) => {
	return request({
		url: '/summary/account/consume/organization/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const exportOrgsumList = (data) => {
	return request({
		url: '/summary/account/consume/organization/export',
		method: 'post',
		responseType: 'blob',
		data: { ...dataObj, content: data || undefined }
	})
}
export const getPsntypesumList = (data) => {
	return request({
		url: '/summary/account/consume/psn/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const exportPsntypesumList = (data) => {
	return request({
		url: '/summary/account/consume/psn/export',
		method: 'post',
		responseType: 'blob',
		data: { ...dataObj, content: data || undefined }
	})
}
// 获取账户基础配置
export const getBaseset = (data) => {
	return request({
		url: '/api/v2/acc/metadata/query',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 保存
export const saveBaseset = (data) => {
	return request({
		url: '/api/v2/acc/metadata/save',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 获取账户合计
export const getAccSum = (data) => {
	return request({
		url: '/api/v3/accInfo/page/sum',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 查询批量补扣结果
export const getResult = (data) => {
	return request({
		url: '/api/v3/acc/consume/batch/repair/deduct/result',
		method: 'get',
		params: { ...dataObj, content: data || undefined }
	})
}
// 补扣失败记录
export const getDeductError = (data) => {
	return request({
		url: '/api/v3/acc/consume/repair/deduct/error/page',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
export const exportDeductError = (data) => {
	return request({
		url: '/api/v3/acc/consume/repair/deduct/error/export',
		method: 'post',
		responseType: 'blob',
		data: { ...dataObj, content: data || undefined }
	})
}

// 红包批量导入校验
export const rechargeBatchImportCheck = (data) => {
	return request({
		url: '/api/v3/acc/wallet/import/check',
		method: 'post',
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		data
	})
}
// 红包批量导入确认
export const rechargeBatchImport = (data) => {
	return request({
		url: '/api/v3/acc/wallet/import/recharge',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 红包批量导入轮询结果查询-轮询
export const rechargeBatchImportResult = () => {
	return request({
		url: '/api/v3/acc/wallet/import/result',
		params: dataObj
	})
}

// 补扣批量导入校验
export const dedcutBatchImportCheck = (data) => {
	return request({
		url: '/api/v3/acc/consume/import/excel/check',
		method: 'post',
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		data
	})
}
// 补扣批量导入确认
export const dedcutBatchImport = (data) => {
	return request({
		url: '/api/v3/acc/consume/import/excel',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 补扣批量导入轮询查询结果
export const dedcutBatchImportResult = () => {
	return request({
		url: '/api/v3/acc/consume/batch/repair/deduct/result',
		params: dataObj
	})
}
// 个人钱包 - 单个撤销 - 通过批次号
export const walletSingleRepealRechargeByBatchNum = data => {
	return request({
		url: '/api/v3/acc/wallet/recharge/batch/num/repeal',
		method: 'post',
		data: { ...dataObj, content: data || {} }
	})
}
// 个人钱包 - 单个撤销 - 通过交易ID
export const walletSingleRepealRechargeByTradeId = data => {
	return request({
		url: '/api/v3/acc/wallet/recharge/single/repeal',
		method: 'post',
		data: { ...dataObj, content: data || {} }
	})
}
// 个人钱包 - 批量撤销 - 通过交易ID
export const walletBatchRepealRechargeByTradeId = data => {
	return request({
		url: '/api/v3/acc/wallet/recharge/batch/repeal',
		method: 'post',
		data: { ...dataObj, content: data || {} }
	})
}
// 个人钱包 - 批量充值撤销错误记录
export const walletRepealErrorRecords = data => {
	return request({
		url: '/api/v3/acc/wallet/recharge/repeal/error',
		method: 'post',
		data: { ...dataObj, content: data || {} }
	})
}
// 个人钱包 - 批量充值撤销错误记录导出
export const walletRepealErrorRecordsExport = data => {
	return request({
		url: '/api/v3/acc/wallet/recharge/repeal/error/export',
		method: 'post',
		responseType: 'blob',
		data: { ...dataObj, content: data || {} }
	})
}

// 个人钱包 - 撤销记录
export const walletRepealRechargeRecords = data => {
	return request({
		url: '/api/v3/acc/wallet/repeal/page',
		method: 'post',
		data: { ...dataObj, content: data || {} }
	})
}
// 个人钱包 - 撤销记录 - 导出
export const walletRepealRechargeRecordsExport = data => {
	return request({
		url: '/api/v3/acc/wallet/repeal/page/export',
		method: 'post',
		responseType: 'blob',
		data: { ...dataObj, content: data || {} }
	})
}
// 补贴钱包 - 单个撤销 - 通过批次号
export const butieSingleRepealRechargeByBatchNum = data => {
	return request({
		url: '/api/v3/acc/subsidy/recharge/batch/num/repeal',
		method: 'post',
		data: { ...dataObj, content: data || {} }
	})
}
// 补贴钱包 - 单个撤销 - 通过交易ID
export const butieSingleRepealRechargeByTradeId = data => {
	return request({
		url: '/api/v3/acc/subsidy/recharge/single/repeal',
		method: 'post',
		data: { ...dataObj, content: data || {} }
	})
}
// 补贴钱包 - 批量撤销 - 通过交易ID
export const butieBatchRepealRechargeByTradeId = data => {
	return request({
		url: '/api/v3/acc/subsidy/recharge/batch/repeal',
		method: 'post',
		data: { ...dataObj, content: data || {} }
	})
}
// 补贴钱包 - 批量充值撤销错误记录
export const butieRepealErrorRecords = data => {
	return request({
		url: '/api/v3/acc/subsidy/recharge/repeal/error',
		method: 'post',
		data: { ...dataObj, content: data || {} }
	})
}
// 补贴钱包 - 批量充值撤销错误记录导出
export const butieRepealErrorRecordsExport = data => {
	return request({
		url: '/api/v3/acc/subsidy/recharge/repeal/error/export',
		method: 'post',
		responseType: 'blob',
		data: { ...dataObj, content: data || {} }
	})
}

// 补贴钱包 - 撤销记录
export const butieRepealRechargeRecords = data => {
	return request({
		url: '/api/v3/acc/subsidy/repeal/page',
		method: 'post',
		data: { ...dataObj, content: data || {} }
	})
}
// 补贴钱包 - 撤销记录 - 导出
export const butieRepealRechargeRecordsExport = data => {
	return request({
		url: '/api/v3/acc/subsidy/repeal/page/export',
		method: 'post',
		responseType: 'blob',
		data: { ...dataObj, content: data || {} }
	})
}
// 充值提现 - 充值明细 -现金充值机失败记录- 查询
export const crashRechargeErrorList = data => {
	return request({
		url: '/api/v3/acc/wallet/cash/recharge/error/record',
		method: 'post',
		data: { ...dataObj, content: data || {} }
	})
}
// 充值提现 - 充值明细 -现金充值机失败记录- 导出
export const crashRechargeErrorListExport = data => {
	return request({
		url: '/api/v3/acc/wallet/cash/recharge/error/record/export',
		method: 'post',
		responseType: 'blob',
		data: { ...dataObj, content: data || {} }
	})
}
// 账户汇总表
export const getAccSummary = (data) => {
	return request({
		url: '/summary/account/query',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 账户汇总表导出
export const exportAccSummary = (data) => {
	return request({
		url: '/summary/account/query/export',
		method: 'post',
		data: { ...dataObj, content: data || undefined },
		responseType: 'blob'
	})
}
